var Feedback = Chaplin.Model.extend({
  initialize: function(){
    var overrides = this.get(this.get('feedbackState'));
    var newAttributes = $.extend(true, this.serialize(), overrides);
    this.set(newAttributes);
  }
});

module.exports = Feedback;